<template>
  <div>
    Display Lookup Configuration Here...
  </div>
</template>

<script>
export default {
  name: 'LookupConfig',
  data: function () {
    return {
    }
  },
  computed: {
  },
  methods: { },
}
</script>

<style lang="scss" scoped>
</style>
